(function () {
  var loc = window.location;
  var host = loc.hostname;
  var path = loc.pathname;
  var search = loc.search || '';
  var hash = loc.hash || '';

  // Only run on easyrebates subdomain
  if (!host.startsWith('easyrebates.')) {
    console.info('[Redirect Test] Not easyrebates subdomain — no action.');
    return;
  }

  var newHost = host.replace('easyrebates.', 'www.');
  var targetUrl = null;
  var ruleUsed = null;

  /**
   * ==============================
   * MANUAL OVERRIDE LOOKUP TABLE
   * ==============================
   */
  var redirectMap = {
    '/products/old-product-handle': '/products/new-product-handle',
    '/collections/legacy/products/weird-handle': '/products/correct-handle',
    '/pages/old-contact': '/pages/contact'
  };

  // 1️⃣ Exact-path override
  if (redirectMap[path]) {
    targetUrl =
      loc.protocol + '//' + newHost +
      redirectMap[path] + search + hash;
    ruleUsed = 'Exact override map';
  }

  // 2️⃣ Product URL
  if (!targetUrl) {
    var productMatch = path.match(/\/products\/([^\/]+)/);
    if (productMatch) {
      targetUrl =
        loc.protocol + '//' + newHost +
        '/products/' + productMatch[1] +
        search + hash;
      ruleUsed = 'Product handle extraction';
    }
  }

  // 3️⃣ Pages
  if (!targetUrl && path.startsWith('/pages/')) {
    targetUrl =
      loc.protocol + '//' + newHost +
      path + search + hash;
    ruleUsed = 'Page passthrough';
  }

  // 4️⃣ Fallback
  if (!targetUrl) {
    targetUrl =
      loc.protocol + '//' + newHost +
      path + search + hash;
    ruleUsed = 'Fallback (host swap only)';
  }

  // 🔎 Console output
  console.groupCollapsed('[Redirect Test]');
  console.log('Current URL:', loc.href);
  console.log('Would redirect to:', targetUrl);
  console.log('Rule used:', ruleUsed);
  console.groupEnd();
  window.location.replace(targetUrl);
  
})();